/* @flow */
import React from 'react';
// $FlowFixMe
import { Modal } from '@bijie/react-bnb';

import withI18n from '../../utils/withI18n';
import { getLabel } from '../../utils/i18n';
import { getUrlParam } from '../../utils/urlUtils';
// import { checkAgentIdByApi } from '../../utils/validate';

type Props = {
  i18n: Object,
  callback: Function,
};

export default
@withI18n
class AgentIdInfo extends React.Component<Props> {
  static defaultProps = {
    i18n: {},
    callback: () => {},
  };

  async componentDidMount() {
    if (getUrlParam('ref')) {
      localStorage.setItem('refId', getUrlParam('ref'));
    }
    const refId = getUrlParam('ref') || localStorage.getItem('refId');
    const ts = sessionStorage.getItem('ts') || '';
    const adBlock = sessionStorage.getItem('ad_block') || '';
    // let isAgent = false;
    const isAgent = true;
    let agentId = '';
    // if (refId) {
    //   isAgent = await checkAgentIdByApi(refId);
    // }
    if (isAgent) {
      agentId = refId;
    } else {
      localStorage.setItem('refId', '');
    }
    const { i18n, callback } = this.props;
    if (!isAgent && !!refId) {
      Modal.info({
        icon: (
          <img
            src={require('./forbidentReg.jpg')}
            alt={getLabel('exchange-register-referralIDIsInvalid', i18n)}
          />
        ),
        content: getLabel('exchange-register-referralIDIsInvalid', i18n),
        okText: getLabel('exchange-register-IUnderstood', i18n),
      });
    }

    callback({ ts, adBlock, agentId });
  }

  render() {
    return <React.Fragment>{null}</React.Fragment>;
  }
}
